module.exports = __webpack_public_path__ + "static/media/starterguide2v2.ba8b62ae.png";